module.exports = __webpack_public_path__ + "04_hair_silver.448ed503.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/04_hair_silver.png
// module id = 4+Cy
// module chunks = 0